import {Switch} from '@wandb/weave/components';
import React, {useState} from 'react';

import {SettingTitle} from '../common/SettingTitle';
import {useMediaSettingsDrawerContext} from '../MediaSettingsDrawerContextProvider';

export const FitImage = () => {
  const {config, updateConfig, unsetConfigField} =
    useMediaSettingsDrawerContext();
  const [shouldFitToDimension, setShouldFitToDimension] = useState(
    config.fitToDimension
  );

  return (
    <div className="flex justify-between">
      <SettingTitle
        title="Fit to available space"
        configField="fitToDimension"
        unsetConfigField={() => {
          unsetConfigField('fitToDimension');
        }}
      />
      <Switch.Root
        aria-label="Toggle fit to available space"
        data-test="fit-available-space-switch"
        checked={shouldFitToDimension}
        onCheckedChange={newValue => {
          setShouldFitToDimension(newValue);
          // Allow the switch to animate before updating the config so that it's more of a smooth
          // transition before the component re-mounts
          setTimeout(() => {
            updateConfig({actualSize: false, fitToDimension: newValue});
          }, 100);
        }}>
        <Switch.Thumb checked={shouldFitToDimension} />
      </Switch.Root>
    </div>
  );
};
